// Content of "AstroLogical_Solutions_Complete_Consultation_Policy.pdf".
const consultationPolicyData = {
  badge: "CONSULTATION POLICY",
  pageTitle: "Consultation Policy - Astro Logical Solutions",
  heading: "Complete Consultation Policy",
  tagline: "An Integrated Astrology & Spiritual Solutions.",
  intro:
    "This policy applies to astrology, numerology, Vastu and related spiritual consultation services offered through AstroLogical Solutions™. It should be read together with the Website Disclaimer, Terms & Conditions, Privacy Policy, Cancellation/Refund Policy and any service-specific terms.",
  highlights: [
    "Booking & Appointments",
    "Rescheduling & Cancellation",
    "Reports & Follow-ups",
    "Privacy & Confidentiality",
  ],
  sections: [
    {
      title: "Scope of This Consultation Policy",
      paragraphs: [
        "This Consultation Policy applies to consultations, reports, analysis, guidance sessions, remedies-related guidance, mobile-number numerology services and other consultation services booked through AstroLogicalSolutions.in or through official AstroLogical Solutions™ communication channels.",
        "Different consultation categories may have additional service-specific terms, which will apply together with this policy.",
      ],
    },
    {
      title: "Nature of Consultation Services",
      paragraphs: [
        "AstroLogical Solutions™ provides traditional and interpretive consultation services in areas including, as applicable:",
      ],
      bullets: [
        "Birth Chart / Kundli Analysis",
        "Career, Business & Job Guidance",
        "Marriage & Relationship Guidance",
        "Health & Wellbeing-oriented astrological guidance",
        "Yearly / Periodic Predictions",
        "Remedies & Spiritual Guidance",
        "Numerology",
        "Mobile Number Numerology / Customization",
        "Vastu Consultation",
        "Other astrology, numerology or spiritual consultation services listed on the website.",
      ],
      after: [
        "These services are provided within traditional systems of knowledge and belief. They are not a substitute for medical, mental-health, legal, financial, investment, tax or other regulated professional advice.",
      ],
    },
    {
      title: "Booking & Appointment Confirmation",
      paragraphs: [
        "A consultation is considered booked only after the required booking information has been received and payment, where applicable, has been successfully confirmed by AstroLogical Solutions™.",
        "An automated order acknowledgement, payment confirmation or enquiry acknowledgement does not by itself guarantee that a particular consultation time has been finally confirmed unless the appointment confirmation states so.",
        "Customers should retain their booking/order reference for future communication.",
      ],
    },
    {
      title: "Information Required From the Customer",
      paragraphs: [
        "Depending on the consultation selected, the customer may be required to provide accurate information such as name, date of birth, exact or best-known birth time, place of birth, mobile number, current location, business details, specific questions or other information relevant to the service.",
        "The customer is responsible for checking the information supplied before the consultation. AstroLogical Solutions™ will not be responsible for an interpretation being affected by incorrect, incomplete, approximate or subsequently changed information supplied by the customer.",
      ],
    },
    {
      title: "Birth Time & Birth Data Accuracy",
      paragraphs: [
        "For astrology consultations, birth time can materially affect a chart and its interpretation. If the customer is uncertain about the birth time, the customer should disclose that uncertainty before the consultation.",
        "Where a service requires birth-time rectification or a specialised rectification process, it should be booked as a separate service if offered. A standard birth-chart consultation should not be assumed to include birth-time rectification unless expressly stated on the service page.",
      ],
    },
    {
      title: "Consultation Duration",
      paragraphs: [
        "The consultation duration will be the duration stated on the relevant service page, quotation or booking confirmation. Customers should join or become available at the scheduled time. The consultation may be considered completed when the stated service duration has elapsed, even if the customer joins late.",
        "Any extension beyond the booked duration is subject to availability and may be chargeable.",
      ],
    },
    {
      title: "Late Arrival / Late Joining",
      paragraphs: [
        "If a customer joins late, the scheduled end time will ordinarily remain unchanged so that subsequent appointments are not affected.",
        "Where reasonably possible, AstroLogical Solutions™ may provide a short grace period, but this is not guaranteed. Customers are encouraged to be ready at least 5–10 minutes before the scheduled consultation time.",
      ],
    },
    {
      title: "Rescheduling",
      paragraphs: [
        "A customer may request rescheduling subject to availability.",
        "A rescheduling request made at least 24 hours before the scheduled appointment may be accommodated without an additional consultation fee, subject to availability.",
        "Requests made less than 24 hours before the appointment may be treated as late rescheduling and may be subject to a rescheduling fee or loss of the appointment, except where AstroLogical Solutions™ approves an exception.",
        "For high-value, customised or specially reserved consultations, different rescheduling terms may be stated at booking.",
      ],
    },
    {
      title: "Cancellation by Customer",
      paragraphs: [
        "Customers should request cancellation through the official contact method stated on the website or booking confirmation.",
        "Because consultation slots are reserved specifically for the customer and may involve preparation, reports or allocation of practitioner time, cancellation and refund eligibility will depend on the timing of the request and the specific service.",
        "Any service-specific cancellation/refund terms displayed at checkout or booking will apply, subject to applicable consumer law and other mandatory legal rights.",
      ],
    },
    {
      title: "Refunds",
      paragraphs: [
        "Where a refund is legally or contractually due, the refund will be processed through the applicable payment method or other method communicated by AstroLogical Solutions™.",
        "A consultation that has already been substantially delivered, a report that has already been prepared/delivered, or a customised service that has already entered production may have different refund treatment, provided the applicable terms were disclosed and are consistent with applicable law.",
        "Nothing in this policy is intended to exclude any mandatory consumer right or remedy available under applicable law.",
      ],
    },
    {
      title: "No-Show",
      paragraphs: [
        "If a customer does not attend or become available for a scheduled consultation and does not provide timely notice, the appointment may be treated as a no-show.",
        "A no-show may result in the consultation being treated as delivered/forfeited for scheduling purposes, subject to the specific service terms and applicable law. Any exception or rescheduling will be at the discretion of AstroLogical Solutions™ and subject to availability.",
      ],
    },
    {
      title: "Technical Issues",
      paragraphs: [
        "For online consultations, customers are responsible for having a suitable device, internet connection, required application and a working phone/email/communication channel.",
        "If a technical problem occurs on the customer's side, reasonable efforts may be made to reconnect. Time lost due to the customer's equipment, connectivity or environment may not automatically extend the appointment.",
        "If a material technical failure is caused by AstroLogical Solutions™ or its consultation platform, reasonable efforts will be made to reschedule or otherwise provide an appropriate remedy.",
      ],
    },
    {
      title: "Reports & Written Predictions",
      paragraphs: [
        "Where a service includes a written report, hand-typed prediction, suggestion, chart analysis or other digital document, the report will be prepared according to the scope stated on the relevant service page.",
        "Delivery time may vary according to the complexity of the service and the information required from the customer. Any stated delivery estimate is subject to timely receipt of the required customer information.",
        "A report is intended for the customer who purchased the service and should not be treated as a guarantee of future events or outcomes.",
      ],
    },
    {
      title: "Follow-Up Questions",
      paragraphs: [
        "If a consultation includes a follow-up facility, the number of follow-up interactions, permitted communication channels and validity period should be stated on the relevant service page.",
        "Follow-up questions should remain within the scope of the original consultation. A substantially new question, additional chart, additional person or new area of analysis may require a separate consultation.",
      ],
    },
    {
      title: "Multiple People / Multiple Charts",
      paragraphs: [
        "A consultation booked for one individual covers the individual specified at booking unless the service description expressly includes multiple people.",
        "Requests to analyse a spouse, partner, family member, business partner, child, employee or another person may require additional information and a separate fee where the service scope does not already include them.",
      ],
    },
    {
      title: "Mobile Number Numerology",
      paragraphs: [
        "Mobile Number Numerology services are based on the number-analysis methodology used by AstroLogical Solutions™. Any suggested or customised number is a traditional numerological recommendation and does not guarantee improvement in business, income, relationships, health, career, social status or any other outcome.",
        "Customers should independently verify availability, ownership, telecom charges, KYC requirements and other practical conditions before purchasing or changing a mobile number.",
      ],
    },
    {
      title: "Vastu Consultation",
      paragraphs: [
        "Vastu guidance is provided within traditional Vastu frameworks. Recommendations may involve layout, directions, placement, colours, objects or other traditional considerations.",
        "Vastu guidance should not override building codes, fire-safety requirements, structural engineering, electrical, plumbing, accessibility, tenancy rules or other professional requirements. Structural or safety-related work should be reviewed by an appropriately qualified professional.",
      ],
    },
    {
      title: "Remedies & Recommended Products",
      paragraphs: [
        "A consultation may include suggestions involving mantras, puja, Rudraksha, gemstones, crystals, Vastu products, spiritual practices or other traditional remedies.",
        "Customers are free to accept or decline such recommendations. Purchase of a recommended product is not a condition for receiving a consultation unless a particular service explicitly includes a product as part of its stated package.",
        "No remedy or product is guaranteed to produce a specific result.",
      ],
    },
    {
      title: "Health-Related Consultation Requests",
      paragraphs: [
        "Astrology or spiritual consultation must not be used as a substitute for medical care. Any health-related discussion during a consultation is limited to the traditional/interpretive framework of the selected service.",
        "AstroLogical Solutions™ does not diagnose, treat, cure or prevent medical or mental-health conditions. Customers should consult a qualified healthcare professional for symptoms, diagnosis, treatment and emergencies.",
      ],
    },
    {
      title: "Financial, Legal & Business Decisions",
      paragraphs: [
        "Consultations may discuss career, business, money or other life themes from a traditional interpretive perspective. Such guidance is not financial, investment, legal, tax or accounting advice.",
        "Customers should obtain independent professional advice before making significant financial, investment, business, legal, tax, employment or contractual decisions.",
      ],
    },
    {
      title: "Confidentiality & Customer Information",
      paragraphs: [
        "Customer information supplied for a consultation should be handled in accordance with the website Privacy Policy and applicable law.",
        "Consultation information may be used to provide the purchased service, communicate with the customer, maintain transaction/service records, resolve disputes and meet legal or regulatory requirements.",
        "Customers should avoid sharing unnecessary highly sensitive information when it is not required for the selected service.",
      ],
    },
    {
      title: "Consultation Recordings",
      paragraphs: [
        "Consultations should not be audio- or video-recorded, published, redistributed or commercially reused by a customer without appropriate consent where required.",
        "If AstroLogical Solutions™ records a consultation for any specific operational purpose, the applicable notice, consent and privacy terms should be followed. The website's Privacy Policy should be read for details.",
      ],
    },
    {
      title: "Intellectual Property in Reports",
      paragraphs: [
        "Consultation reports, written predictions, charts, explanatory documents, templates and other original materials prepared by AstroLogical Solutions™ are provided for the customer's personal use unless a written commercial licence or other permission states otherwise.",
        "Unauthorised resale, copying, publication, redistribution, training use or commercial exploitation may be restricted by applicable intellectual-property rights.",
      ],
    },
    {
      title: "Consultation Content & Guarantees",
      paragraphs: [
        "AstroLogical Solutions™ does not guarantee that a consultation will produce a particular personal, professional, financial, relationship, health or other result.",
        "The purpose of consultation is to provide traditional interpretation, perspective, guidance and recommendations. Customers remain responsible for evaluating the information and making their own decisions.",
      ],
    },
    {
      title: "Practitioner / Consultant Availability",
      paragraphs: [
        "Appointments are subject to consultant availability. If AstroLogical Solutions™ needs to cancel or materially reschedule an appointment, reasonable efforts will be made to inform the customer and offer an appropriate alternative, such as rescheduling, another available consultant where suitable, or a refund where applicable.",
      ],
    },
    {
      title: "Misconduct & Disruptive Behaviour",
      paragraphs: [
        "AstroLogical Solutions™ reserves the right, subject to applicable law, to end or refuse a consultation where a customer engages in abusive, threatening, discriminatory, harassing, fraudulent or materially disruptive conduct.",
        "Where a service is ended because of customer misconduct, refund eligibility will be determined according to the applicable service terms and law.",
      ],
    },
    {
      title: "Age & Guardian Considerations",
      paragraphs: [
        "Customers should use consultation services only where legally permitted. For consultations involving minors, the website may require consent or participation of a parent or legal guardian as appropriate.",
        "The consultation should not be used to make medical, legal, educational or other high-stakes decisions concerning a minor without appropriate qualified professional input.",
      ],
    },
    {
      title: "Testimonials & Customer Experiences",
      paragraphs: [
        "Customer testimonials and experiences, where published with appropriate permission, reflect the views or experiences of the relevant customers. They do not constitute a guarantee that another customer will experience the same outcome.",
        "AstroLogical Solutions™ should not present a testimonial as scientific proof or as a guaranteed result.",
      ],
    },
    {
      title: "Grievance & Customer Support",
      paragraphs: [
        "Customers should first contact AstroLogical Solutions™ through the official support/contact details displayed on the website for booking, service, payment, report or consultation concerns.",
        "The website should prominently display the applicable grievance contact information required for the business and applicable e-commerce rules. The Consumer Protection (E-Commerce) Rules and later amendments should be reviewed when finalising the website's operational grievance process.",
      ],
    },
    {
      title: "Policy Changes",
      paragraphs: [
        "AstroLogical Solutions™ may update this Consultation Policy from time to time to reflect changes in services, business processes, technology or applicable law. The updated version should be published on the website with an effective/revision date.",
        "For an existing booking, the terms applicable at the time of booking should be considered together with any mandatory legal rights and any service-specific terms.",
      ],
    },
    {
      title: "Governing Terms & Applicable Law",
      paragraphs: [
        "This Consultation Policy forms part of the website's broader terms and policies. The final version should specify the correct legal entity, registered/business address, contact details and any jurisdiction/dispute provisions after review by qualified legal counsel.",
        "Nothing in this policy is intended to restrict rights or remedies that cannot lawfully be excluded.",
      ],
    },
  ],
};

export default consultationPolicyData;
